export const FILTER_COUNT_BADGE_MAX_SINGLE_DIGIT = 9;

export const CLOSE_REVIEW_LOGS_DRAWER_EVENT = "promptlayer:close-review-logs-drawer";

export const SCROLL_REVIEW_LOGS_DRAWER_TO_TOP_EVENT =
  "promptlayer:scroll-review-logs-drawer-to-top";

export const POPOVER_SIDE_OFFSET_PX = 8;

export const TRUNCATED_FILTER_VALUES_GAP_PX = 6;

export const TRUNCATED_FILTER_VALUES_OVERFLOW_INDICATOR_WIDTH_PX = 38;

export const FILTER_VALUE_TOOLTIP_MAX_WIDTH_CLASS = "max-w-[220px]";
